(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('ScheduledTaskDetailController', ScheduledTaskDetailController);

    ScheduledTaskDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity', 'translationHandler'];

    function ScheduledTaskDetailController($scope, $rootScope, previousState, entity, translationHandler) {
        var vm = this;

        vm.scheduledTask = entity;
        if (vm.scheduledTask && vm.scheduledTask.documentDocumentNumber) {
            translationHandler.setSubject(vm.scheduledTask.documentDocumentNumber, 'eDocumentsApp.scheduledTask.home.title');
        }
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('eDocumentsApp:scheduledTaskUpdate', function (result) {
            vm.scheduledTask = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
